import { render, staticRenderFns } from "./RelatarErro.vue?vue&type=template&id=cfcee054&scoped=true"
import script from "./RelatarErro.vue?vue&type=script&lang=js"
export * from "./RelatarErro.vue?vue&type=script&lang=js"
import style0 from "./RelatarErro.vue?vue&type=style&index=0&id=cfcee054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcee054",
  null
  
)

export default component.exports